module.exports = __webpack_public_path__ + "eb9cc6c51c5a51ef15f403ff9591d448.svg";